


<section>
  <div>
    <app-header></app-header>
  </div>
  <main>
    <router-outlet></router-outlet>
  </main>
  <div>
    <app-footer></app-footer>
  </div>
</section>
